import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import { Form, Select, Table } from 'tdesign-react';
import { getExamineMsg } from '@/services/topicService';
import useTable from '@/hooks/useTable';
import { toTsOptions } from '@/utils/common';
import { offsetPositionOptions } from '@/utils/constant';
import { columns } from '..';

const { FormItem } = Form;

const initialData = {
  initialPosition: 'latest',
  messagePosition: 1,
};

export default function ExamineMessage({ commonProps }) {
  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getExamineMsg({
      ...commonProps,
      subscription: 'sub',
      ...params,
      messagePosition: 1, // 固定1
    });
    setData(data);
  });

  const { header, config, setData, doSearch, form } = useTable({
    columnController: null,
    onSearch: loadData,
    refresh: null,
    columns,
    search: (
      <FormItem name='initialPosition'>
        <Select options={toTsOptions(offsetPositionOptions)} />
      </FormItem>
    ),
  });

  useEffect(() => {
    setTimeout(() => form.setFieldsValue(initialData));
  }, [doSearch, form]);

  return (
    <>
      {header}
      <Table {...config} />
    </>
  );
}
